import { useState, useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";
import { useTheme } from "./hooks/useTheme";
import { ThemeContext, ThemeSettingsContext } from "./context/ThemeContext";
import { TitleUpdater } from "./context/TitleUpdater";
import { PageShell } from "./components/PageShell/PageShell";
import { HomePage } from "./pages/HomePage/HomePage";
import { AboutPage } from "./pages/AboutPage/AboutPage";
import { NowPage } from "./pages/NowPage/NowPage";
// import { WorkPage } from "./pages/WorkPage/WorkPage";
// import { ProjectDetail } from "./pages/ProjectDetail/ProjectDetail";
// import { NotesPage } from "./pages/NotesPage/NotesPage";
// import { NoteDetail } from "./pages/NoteDetail/NoteDetail";
import { BusinessCard } from "./pages/BusinessCard/BusinessCard";
import { NotFound } from "./pages/NotFound/NotFound";

const ACCENT_OPTIONS = ["#d97757", "#a64a2e", "#7a8a4c", "#b16a8c"];

function Layout() {
  const location = useLocation();
  const [dark, setDark] = useState<boolean>(() => {
    return localStorage.getItem("mc-dark") === "1";
  });
  const [accent, setAccent] = useState<string>(() => {
    return localStorage.getItem("mc-accent") || ACCENT_OPTIONS[0];
  });

  const theme = useTheme({ dark, accent });

  useEffect(() => {
    localStorage.setItem("mc-dark", dark ? "1" : "0");
    document.documentElement.style.background = theme.bg;
  }, [dark, theme.bg]);

  useEffect(() => {
    localStorage.setItem("mc-accent", accent);
  }, [accent]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [location.pathname]);

  return (
    <ThemeSettingsContext.Provider value={{ dark, setDark, accent, setAccent }}>
      <ThemeContext.Provider value={theme}>
        <PageShell theme={theme}>
          <TitleUpdater />
          <Outlet />
        </PageShell>
      </ThemeContext.Provider>
    </ThemeSettingsContext.Provider>
  );
}

function ErrorFallback() {
  return (
    <div style={{ padding: 40 }}>
      <h1>Etwas ist schiefgelaufen</h1>
      <p>Bitte lade die Seite neu.</p>
    </div>
  );
}

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorFallback />,
      children: [
        { index: true, element: <HomePage /> },
        { path: "about", element: <AboutPage /> },
        { path: "now", element: <NowPage /> },
        // { path: "work", element: <WorkPage /> },
        // { path: "work/:key", element: <ProjectDetail /> },
        // { path: "notes", element: <NotesPage /> },
        // { path: "notes/:key", element: <NoteDetail /> },
        { path: "businesscard", element: <BusinessCard /> },
        { path: "*", element: <NotFound /> },
      ],
    },
  ],
  {
    basename: import.meta.env.MODE === "develop" ? "/develop" : "/",
  },
);

export function App() {
  return <RouterProvider router={router} />;
}
